import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { EmailAddressAudit } from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-email-address-audit-list',
  templateUrl: './email-address-audit-list.component.html',
  styleUrls: ['./email-address-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailAddressAuditListComponent implements OnInit {
  @Input() emailAddressId: number;
  @Input() loading: boolean;
  @Input() emailAddressAudits: EmailAddressAudit[];

  @Output() loadEmailAddress = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadEmailAddress.emit(this.emailAddressId);
  }

  onNextPage() {
    this.nextPage.emit(this.emailAddressId);
  }
}
